export default __webpack_public_path__ + "static/media/nissan.d4d66098.svg";